export const BUTTON_LABELS = {
  UPLOAD_AVATAR: 'Upload',
  SELECT_IMAGE: 'Select Image',
  SAVE_AVATAR: 'Save',
  EDIT_AVATAR: 'Edit',
  CHANGE_AVATAR: 'Change',
  REMOVE_IMAGE: 'Remove Image',
  CHANGE_IMAGE: 'Change Image',
  UPLOAD_IMAGE: 'Upload Image',
};

// export enum BUTTON_SIZES {
//   SM = 'small',
//   MD = 'medium',
//   LG = 'large',
// }
